const _excluded = ["className", "type", "size", "skin", "prefixIcon", "suffixIcon", "as", "ref", "children", "fluid", "intent", "disabled", "loading", "loadingText", "tooltip", "noWrap", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "bi", "roundness", "onClick", "testId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useCallback } from 'react';
import cn from 'classnames';
import { useBiClick } from "../BiTracking";
import { ConditionalWrapper } from "../ConditionalWrapper";
import { useIntentBehavior } from "../IntentBehavior";
import { Spinner } from "../Spinner";
import { Tooltip } from "../Tooltip";
import classes from "./Button.module.scss";
import { spinnerSize } from "./Button.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Button(props) {
  const {
      className,
      type,
      size = 'medium',
      skin = 'primary',
      prefixIcon,
      suffixIcon,
      as,
      ref,
      children,
      fluid,
      intent,
      disabled,
      loading,
      loadingText,
      tooltip,
      noWrap,
      // SplitButton introduces these props, which causes React console errors about unknown props for button element, so we ignore them here.
      disableElevation: _disableElevation,
      disableFocusRipple: _disableFocusRipple,
      disableRipple: _disableRipple,
      fullWidth: _fullWidth,
      bi,
      roundness = 's',
      onClick,
      testId
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    getDisabled,
    getTooltip
  } = useIntentBehavior();
  const disabledFromIntent = intent ? getDisabled(intent) : false;
  const tooltipFromIntent = intent ? getTooltip(intent) : null;
  const hasTooltip = !!(tooltip !== null && tooltip !== void 0 && tooltip.title) || !!tooltipFromIntent;
  const Component = as || 'button';
  const isOutline = skin === 'dangerOutline' || skin === 'primaryOutline';
  const logBiClick = useBiClick();
  const handleClick = useCallback(event => {
    if (bi !== null && bi !== void 0 && bi.name) {
      logBiClick({
        entityType: 'button',
        entityName: bi.name,
        actionType: 'click',
        data: bi.data
      });
    }
    return onClick === null || onClick === void 0 ? void 0 : onClick(event);
  }, [bi, logBiClick, onClick]);
  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    condition: hasTooltip,
    wrapper: children => /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({}, tooltip || {
      placement: 'top',
      title: tooltipFromIntent
    }), {}, {
      children: /*#__PURE__*/_jsx("div", {
        className: cn(classes.wrapper, {
          [classes.fluid]: fluid
        }, className),
        "data-testid": testId && "".concat(testId, "-wrapper"),
        children: children
      })
    })),
    children: /*#__PURE__*/_jsxs(Component, _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      type: type || 'button',
      disabled: disabledFromIntent || disabled || loading,
      className: cn(classes.root, classes["".concat(size, "Size")], classes["".concat(skin, "Skin")], classes["".concat(roundness, "Roundness")], {
        [classes.fluid]: fluid,
        [classes.noWrap]: noWrap
      }, !hasTooltip && className),
      onClick: handleClick
    }, rest), testId != null ? {
      'data-testid': testId
    } : {}), {}, {
      children: [loading ? /*#__PURE__*/_jsx("div", {
        className: classes.prefixIcon,
        "data-testid": testId && "".concat(testId, "-loading"),
        children: /*#__PURE__*/_jsx(Spinner, {
          size: spinnerSize[size],
          intent: isOutline ? 'default' : 'primary'
        })
      }) : prefixIcon && /*#__PURE__*/_jsx("div", {
        className: classes.prefixIcon,
        children: prefixIcon
      }), loading ? loadingText : children, suffixIcon ? /*#__PURE__*/_jsx("div", {
        className: classes.suffixIcon,
        children: suffixIcon
      }) : null]
    }))
  });
}